import { computed, observable } from "mobx";
import Model from "~/models/Model";

class CustomerStatistic extends Model {
  /**
   * @property {number|null}
   */
  @observable customerId = null;

  /**
   * @property {number|null}
   */
  @observable activeToursCount = null;

  /**
   * @property {number|null}
   */
  @observable uiMeet3dActiveToursCount = null;

  /**
   * @property {number|null}
   */
  @observable uiMeet3dSecondsTotal = null;

  /**
   * @property {number|null}
   */
  @observable uiMeet3dLeadsCount = null;

  /**
   * @property {number|null}
   */
  @observable uiMeet3dEventNotificationsCount = null;

  @computed
  get uiMeet3dMinutesTotal() {
    if (this.uiMeet3dSecondsTotal === null) {
      return null;
    }

    if (this.uiMeet3dSecondsTotal === 0) {
      return 0;
    }

    return Math.round(this.uiMeet3dSecondsTotal / 60);
  }
}

export default CustomerStatistic;
